import { $ } from "@/plug/Axios";

export default {
  /**
   * 360度评测
   */
  appraise_applyAppraise: {
    /*
     * 评价
     * content json, itemId(详情返回的的itemId)|score(数字0-5, 0代表无法评估)|reason(score为0,1,5时必填) (string query required)
     * id id (integer query required)
     */
    post: (p, c) => $.post("/api/bms/personnel/appraise/applyAppraise", p, c)
  },
  appraise_detailForInternal: {
    /*
     * 详情-内部管理-360度评测
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/bms/personnel/appraise/detailForInternal", p, c)
  },
  appraise_detailForPersonnel: {
    /*
     * 详情-人事平台-员工评测记录
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/bms/personnel/appraise/detailForPersonnel", p, c)
  },
  appraise_downloadMould: {
    /*
     * 下载评测员工导入模版
     */
    get: (p, c) => $.get("/api/bms/personnel/appraise/downloadMould", p, c)
  },
  appraise_exportForAppraise: {
    /*
     * 导出-人事平台-360度评测-员工评测
     * month 月 (integer query required)
     * year 年 (integer query required)
     */
    get: (p, c) => $.get("/api/bms/personnel/appraise/exportForAppraise", p, c)
  },
  appraise_listAppraiseForSelf: {
    /*
     * 列表-基础平台-内部管理-360度评测
     */
    get: (p, c) =>
      $.get("/api/bms/personnel/appraise/listAppraiseForSelf", p, c)
  },
  appraise_listForAppraise: {
    /*
     * 列表-人事平台-360度评测-员工评测
     */
    get: (p, c) => $.get("/api/bms/personnel/appraise/listForAppraise", p, c)
  },
  appraise_listForAppraiseRecord: {
    /*
     * 列表-人事平台-360度评测-员工评测记录
     */
    get: (p, c) =>
      $.get("/api/bms/personnel/appraise/listForAppraiseRecord", p, c)
  },
  appraise_listSimpleAdmin: {
    /*
     * 简易被评价人列表
     * month 月 (integer query required)
     * year 年 (integer query required)
     */
    get: (p, c) => $.get("/api/bms/personnel/appraise/listSimpleAdmin", p, c)
  },
  appraise_removeForAppraise: {
    /*
     * 删除评测员工
     * id id (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/bms/personnel/appraise/removeForAppraise", p, c)
  },
  appraise_removeRecord: {
    /*
     * 删除评测记录
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/personnel/appraise/removeRecord", p, c)
  },
  appraise_upload: {
    /*
     * 导入评测员工
     * excelFile excelFile (file formData required)
     */
    post: (p, c) => $.post("/api/bms/personnel/appraise/upload", p, c)
  },

  /**
   * 上报异议
   */
  enrollDissent_addDispose: {
    /*
     * 添加处理内容
     * content 处理内容 (string query required)
     * id 列表id (integer query required)
     * result 处理结果（通过、拒绝） (string query required)
     */
    put: (p, c) => $.put("/api/bms/personnel/enrollDissent/addDispose", p, c)
  },
  enrollDissent_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/personnel/enrollDissent/list", p, c)
  },
  enrollDissent_listRecord: {
    /*
     * 上报异议处理记录
     * monthReviewEnrollId monthReviewEnrollId (integer query required)
     */
    get: (p, c) => $.get("/api/bms/personnel/enrollDissent/listRecord", p, c)
  },
  enrollDissent_updateOperatorId: {
    /*
     * 变更处理人
     * id 列表id (integer query required)
     * newOperatorId 新处理人 (integer query required)
     */
    put: (p, c) =>
      $.put("/api/bms/personnel/enrollDissent/updateOperatorId", p, c)
  },

  /**
   * 快递结算管理
   */
  expressage_check_downloadMould: {
    /*
     * 下载模版
     */
    get: (p, c) =>
      $.get("/api/bms/personnel/expressage/check/downloadMould", p, c)
  },
  expressage_check_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/bms/personnel/expressage/check/export", p, c)
  },
  expressage_check_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/personnel/expressage/check/list", p, c)
  },
  expressage_check_remove: {
    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/bms/personnel/expressage/check/remove", p, c)
  },
  expressage_check_upload: {
    /*
     * 导入
     * excelFile excelFile (file formData required)
     */
    post: (p, c) => $.post("/api/bms/personnel/expressage/check/upload", p, c)
  },
  expressage_record_downloadMould: {
    /*
     * 下载模版（内部管理）
     */
    get: (p, c) =>
      $.get("/api/bms/personnel/expressage/record/downloadMould", p, c)
  },
  expressage_record_export: {
    /*
     * 导出（人事平台）
     */
    get: (p, c) => $.get("/api/bms/personnel/expressage/record/export", p, c)
  },
  expressage_record_exportForEmployee: {
    /*
     * 导出（内部管理）
     */
    get: (p, c) =>
      $.get("/api/bms/personnel/expressage/record/exportForEmployee", p, c)
  },
  expressage_record_getByNo: {
    /*
     * 根据快递单号查询是否已存在
     * expressageNo 快递单号 (string query required)
     */
    get: (p, c) => $.get("/api/bms/personnel/expressage/record/getByNo", p, c)
  },
  expressage_record_list: {
    /*
     * 列表（人事平台）
     */
    get: (p, c) => $.get("/api/bms/personnel/expressage/record/list", p, c)
  },
  expressage_record_listForEmployee: {
    /*
     * 列表（内部管理）
     */
    get: (p, c) =>
      $.get("/api/bms/personnel/expressage/record/listForEmployee", p, c)
  },
  expressage_record_remove: {
    /*
     * 删除(内部管理
     * id id (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/bms/personnel/expressage/record/remove", p, c)
  },
  expressage_record_save: {
    /*
     * 添加（内部管理及手机端使用）
     * expressageNoList 快递单号列表 (array query required)
     * profitDepartment 利润中心 (string query required)
     */
    post: (p, c) => $.post("/api/bms/personnel/expressage/record/save", p, c)
  },
  expressage_record_syncStatus: {
    /*
     * 同步快递状态
     * id id (integer query required)
     */
    put: (p, c) =>
      $.put("/api/bms/personnel/expressage/record/syncStatus", p, c)
  },
  expressage_record_updateStatus: {
    /*
     * 编辑快递状态（人事平台）
     * id id (integer query required)
     * status 状态（已扫码|已退件|已丢件|已寄达） (string query required)
     */
    put: (p, c) =>
      $.put("/api/bms/personnel/expressage/record/updateStatus", p, c)
  },
  expressage_record_updateStatusByNo: {
    /*
     * 编辑快递状态（手机端使用）
     * expressageNo 快递单号 (string query required)
     * status 状态（已退件|已丢件） (string query required)
     */
    put: (p, c) =>
      $.put("/api/bms/personnel/expressage/record/updateStatusByNo", p, c)
  },
  expressage_record_updateStatusForEmployee: {
    /*
     * 编辑快递状态（内部管理使用）
     * id id (integer query required)
     * status 状态（已退件|已丢件） (string query required)
     */
    put: (p, c) =>
      $.put(
        "/api/bms/personnel/expressage/record/updateStatusForEmployee",
        p,
        c
      )
  },
  expressage_record_upload: {
    /*
     * 批量导入快递（内部管理）
     * excelFile excelFile (file formData required)
     */
    post: (p, c) => $.post("/api/bms/personnel/expressage/record/upload", p, c)
  },

  /**
   * 未来学苑
   */
  future_commitHomework: {
    /*
     * 提交作业-基础平台-内部管理-未来学苑-课程及作业
     * courseId courseId (integer query required)
     * homeworkUrl 作业内容 (string query required)
     */
    post: (p, c) => $.post("/api/bms/personnel/future/commitHomework", p, c)
  },
  future_downloadMould: {
    /*
     * 下载模板(跨部门协作评分人)
     */
    get: (p, c) => $.get("/api/bms/personnel/future/downloadMould", p, c)
  },
  future_exportMember: {
    /*
     * 导出成员列表
     */
    get: (p, c) => $.get("/api/bms/personnel/future/exportMember", p, c)
  },
  future_getNoteContent: {
    /*
     * 查看工作成果内容（富文本）
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/bms/personnel/future/getNoteContent", p, c)
  },
  future_listClass: {
    /*
     * 列表-基础平台-未来学苑-班级列表
     */
    get: (p, c) => $.get("/api/bms/personnel/future/listClass", p, c)
  },
  future_listClassForInternal: {
    /*
     * 列表-基础平台-内部管理-未来学苑-我的班级
     */
    get: (p, c) => $.get("/api/bms/personnel/future/listClassForInternal", p, c)
  },
  future_listComment: {
    /*
     * 列表-基础平台-未来学苑-评价列表
     */
    get: (p, c) => $.get("/api/bms/personnel/future/listComment", p, c)
  },
  future_listCommentForInternal: {
    /*
     * 列表-基础平台-内部管理-未来学苑-评价列表
     */
    get: (p, c) =>
      $.get("/api/bms/personnel/future/listCommentForInternal", p, c)
  },
  future_listCommentForScoring: {
    /*
     * 列表-基础平台-未来学苑-待我评价
     */
    get: (p, c) =>
      $.get("/api/bms/personnel/future/listCommentForScoring", p, c)
  },
  future_listCommittees: {
    /*
     * 查看管委会成员，配置key=future_committee_admin_ids，自己编辑
     */
    get: (p, c) => $.get("/api/bms/personnel/future/listCommittees", p, c)
  },
  future_listCourse: {
    /*
     * 列表-基础平台-未来学苑-课程列表
     */
    get: (p, c) => $.get("/api/bms/personnel/future/listCourse", p, c)
  },
  future_listCourseRecord: {
    /*
     * 作业与点评列表-基础平台-未来学苑-课程列表点击弹出
     * id 课程列表返回的id (integer query required)
     */
    get: (p, c) => $.get("/api/bms/personnel/future/listCourseRecord", p, c)
  },
  future_listMember: {
    /*
     * 列表-基础平台-未来学苑-学员列表
     */
    get: (p, c) => $.get("/api/bms/personnel/future/listMember", p, c)
  },
  future_listNote: {
    /*
     * 工作成果列表-学员列表后面放按钮（内部和未来学苑都要）
     * classId 班级id (integer query required)
     * memberId 学员id (integer query required)
     */
    get: (p, c) => $.get("/api/bms/personnel/future/listNote", p, c)
  },
  future_listRecordForInternal: {
    /*
     * 列表-基础平台-内部管理-未来学苑-课程及作业
     */
    get: (p, c) =>
      $.get("/api/bms/personnel/future/listRecordForInternal", p, c)
  },
  future_listSimpleClass: {
    /*
     * 简易班级列表
     */
    get: (p, c) => $.get("/api/bms/personnel/future/listSimpleClass", p, c)
  },
  future_removeClass: {
    /*
     * 删除班级
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/personnel/future/removeClass", p, c)
  },
  future_removeComment: {
    /*
     * 删除评分人
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/personnel/future/removeComment", p, c)
  },
  future_removeCourse: {
    /*
     * 删除课程，有学生提交作业了不可删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/personnel/future/removeCourse", p, c)
  },
  future_removeMember: {
    /*
     * 删除学员
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/personnel/future/removeMember", p, c)
  },
  future_saveClass: {
    /*
     * 添加编辑班级
     * endTime 结束时间 (string query )
     * headerTeacherId 班主任 (integer query )
     * id  (integer query )
     * name 班级名称 (string query )
     * scoreStatus 评分状态 (string query )
     * startTime 开班时间 (string query )
     */
    post: (p, c) => $.post("/api/bms/personnel/future/saveClass", p, c)
  },
  future_saveCourse: {
    /*
     * 添加编辑课程
     * classId 班级ID， 不可编辑 (integer query required)
     * endTime 结束时间 (string query required)
     * id id (integer query )
     * intro 课程介绍 (string query required)
     * name 课程名称 (string query required)
     * startTime 开始时间 (string query required)
     * teacherId 上课老师 (integer query required)
     */
    post: (p, c) => $.post("/api/bms/personnel/future/saveCourse", p, c)
  },
  future_saveHomework: {
    /*
     * 添加编辑作业
     * deadline 截止时间 (string query required)
     * homeworkContent 作业内容 (string query required)
     * id 课程列表返回的id (integer query required)
     */
    post: (p, c) => $.post("/api/bms/personnel/future/saveHomework", p, c)
  },
  future_saveMember: {
    /*
     * 添加编辑学员
     * classId 班级ID (integer query )
     * id  (integer query )
     * intro 学员自我介绍 (string query )
     * memberId 成员D (integer query )
     * recommendContent 部门领导推荐评语 (string query )
     */
    post: (p, c) => $.post("/api/bms/personnel/future/saveMember", p, c)
  },
  future_saveNote: {
    /*
     * 添加编辑工作成果-基础平台-内部管理-未来学苑-工作成果
     * classId 班级id (integer query required)
     * content 内容 (string query required)
     * id id (integer query )
     * title 标题 (string query required)
     */
    post: (p, c) => $.post("/api/bms/personnel/future/saveNote", p, c)
  },
  future_saveScore: {
    /*
     * 添加评分
     * commentContent 评分理由 (string query required)
     * hideName 是否匿名,仅type为同学互评可以选是 (string query )
     * id 待我评分列表返回的id (integer query required)
     * score 得分 (integer query required)
     */
    post: (p, c) => $.post("/api/bms/personnel/future/saveScore", p, c)
  },
  future_saveStudyOrWorkScore: {
    /*
     * 添加表现或评分-作业与点评列表, 是班主任才可以
     * commentContent 上课表现评语 (string query )
     * courseId courseId (integer query required)
     * memberId memberId (integer query required)
     * score 得分 (integer query required)
     * type 类型:上课表现|课后作业 (string query required)
     */
    post: (p, c) =>
      $.post("/api/bms/personnel/future/saveStudyOrWorkScore", p, c)
  },
  future_startScoring: {
    /*
     * 开启评分
     * id id (integer query required)
     */
    post: (p, c) => $.post("/api/bms/personnel/future/startScoring", p, c)
  },
  future_uploadMember: {
    /*
     * 批量导入学员
     * excelFile excelFile (file formData required)
     */
    post: (p, c) => $.post("/api/bms/personnel/future/uploadMember", p, c)
  },
  future_uploadScoreAdmin: {
    /*
     * 导入跨部门协作评分人
     * excelFile excelFile (file formData required)
     * id 班级列表返回的id (integer query required)
     */
    post: (p, c) => $.post("/api/bms/personnel/future/uploadScoreAdmin", p, c)
  },

  /**
   * 班主任带班人数
   */
  incomeStudent_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/bms/personnel/incomeStudent/export", p, c)
  },
  incomeStudent_exportDetail: {
    /*
     * 导出班主任带班人数
     * month 月份 (integer query )
     * year 年份 (integer query )
     */
    get: (p, c) => $.get("/api/bms/personnel/incomeStudent/exportDetail", p, c)
  },
  incomeStudent_initStudentCount: {
    /*
     * 临时方法-定时任务生成带班人数
     * assignTime 截止时间 (string query )
     */
    put: (p, c) =>
      $.put("/api/bms/personnel/incomeStudent/initStudentCount", p, c)
  },
  incomeStudent_listDetail: {
    /*
     * 带班人数详情
     * batch 批次 (string query )
     * id id (integer query required)
     * level 层次 (string query )
     * majorId 专业 (integer query )
     * name 学生姓名 (string query )
     * siteId 学校 (integer query )
     */
    get: (p, c) => $.get("/api/bms/personnel/incomeStudent/listDetail", p, c)
  },
  incomeStudent_listForHeaderTeacher: {
    /*
     * 基础平台-班主任带班人数列表
     */
    get: (p, c) =>
      $.get("/api/bms/personnel/incomeStudent/listForHeaderTeacher", p, c)
  },
  incomeStudent_listForPersonnel: {
    /*
     * 人事平台-班主任带班人数列表
     */
    get: (p, c) =>
      $.get("/api/bms/personnel/incomeStudent/listForPersonnel", p, c)
  },
  incomeStudent_updatePer: {
    /*
     * 编辑
     * highStudentCount 优质生源数量 (integer query required)
     * id id (integer query required)
     * lowStudentCount 非优质生源数量 (integer query required)
     */
    put: (p, c) => $.put("/api/bms/personnel/incomeStudent/updatePer", p, c)
  },
  incomeStudent_upload: {
    /*
     * 导入
     * excelFile excelFile (file formData required)
     */
    post: (p, c) => $.post("/api/bms/personnel/incomeStudent/upload", p, c)
  },

  /**
   * 内部员工
   */
  internalEmployee_downloadMould: {
    /*
     * 下载模版
     */
    get: (p, c) =>
      $.get("/api/bms/personnel/internalEmployee/downloadMould", p, c)
  },
  internalEmployee_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/bms/personnel/internalEmployee/export", p, c)
  },
  internalEmployee_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/personnel/internalEmployee/list", p, c)
  },
  internalEmployee_update: {
    /*
     * 编辑
     * ableStatus 启用禁用 (string query required)
     * id 行ID (integer query required)
     * jobPosition 工作岗位 (string query required)
     * leaderFlag 是否负责人（限是否） (string query required)
     */
    put: (p, c) => $.put("/api/bms/personnel/internalEmployee/update", p, c)
  },
  internalEmployee_updateJobPosition: {
    /*
     * 批量更新工作岗位
     * ids 行IDS (array query required)
     * jobPosition 工作岗位 (string query required)
     */
    put: (p, c) =>
      $.put("/api/bms/personnel/internalEmployee/updateJobPosition", p, c)
  },
  internalEmployee_upload: {
    /*
     * 导入员工
     * excelFile excelFile (file formData required)
     */
    post: (p, c) => $.post("/api/bms/personnel/internalEmployee/upload", p, c)
  },

  /**
   * 业绩月份
   */
  monthReview_dingNotice: {
    /*
     * 一键提醒
     * id id (integer query required)
     */
    put: (p, c) => $.put("/api/bms/personnel/monthReview/dingNotice", p, c)
  },
  monthReview_export: {
    /*
     * 导出
     * id 列表id (integer query required)
     * type 类型 (string query )
     */
    get: (p, c) => $.get("/api/bms/personnel/monthReview/export", p, c)
  },
  monthReview_finish: {
    /*
     * 标记完成（阶段为下发核对中时显示）
     * id id (integer query required)
     * performanceTime 业绩发放或退费时间 (string query )
     * sixtyPayed 首次补缴奖励是否已发放 (string query )
     */
    put: (p, c) => $.put("/api/bms/personnel/monthReview/finish", p, c)
  },
  monthReview_initData: {
    /*
     * 刷新数据(未开始阶段)
     * id id (integer query required)
     */
    post: (p, c) => $.post("/api/bms/personnel/monthReview/initData", p, c)
  },
  monthReview_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/personnel/monthReview/list", p, c)
  },
  monthReview_publishForCheck: {
    /*
     * 下发核对
     * id id (integer query required)
     */
    put: (p, c) => $.put("/api/bms/personnel/monthReview/publishForCheck", p, c)
  },
  monthReview_remove: {
    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/personnel/monthReview/remove", p, c)
  },
  monthReview_removeReviewEnroll: {
    /*
     * 删除单条合同数据
     * id 合同列表返回的id (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/bms/personnel/monthReview/removeReviewEnroll", p, c)
  },
  monthReview_removeReviewTeacher: {
    /*
     * 删除单条业绩老师
     * id 详情返回的列表id (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/bms/personnel/monthReview/removeReviewTeacher", p, c)
  },
  monthReview_save: {
    /*
     * 添加|编辑
     * contractCancelEndTime 退费截止时间 (string query )
     * contractCancelStartTime 退费开始时间 (string query )
     * contractFinishEndTime 合同成交结束时间 (string query )
     * contractFinishStartTime 合同成交开始时间 (string query )
     * firstFeeConfirmEndTime 首次学费补缴截止时间 (string query )
     * firstFeeConfirmStartTime 首次学费补缴开始时间 (string query )
     * id id，编辑传入 (integer query )
     * month 月份 (integer query required)
     * year 年度 (integer query required)
     */
    post: (p, c) => $.post("/api/bms/personnel/monthReview/save", p, c)
  },

  /**
   * 招生业绩核对
   */
  monthReviewTeacher_addDissent: {
    /*
     * 新增上报异议
     * id 列表id (integer query required)
     * remark 上报异议备注 (string query required)
     * schoolRollId 合同编号 (integer query required)
     */
    put: (p, c) =>
      $.put("/api/bms/personnel/monthReviewTeacher/addDissent", p, c)
  },
  monthReviewTeacher_confirmStatus: {
    /*
     * 确认|上报异议业绩核对（招生老师）
     * remark 上报异议备注 (string query )
     * reviewEnrollId 详情id (integer query required)
     * status 状态：已确认|上报异议 (string query required)
     */
    put: (p, c) =>
      $.put("/api/bms/personnel/monthReviewTeacher/confirmStatus", p, c)
  },
  monthReviewTeacher_details: {
    /*
     * 详情
     * confirmStatus 确认状态：未确认|已确认|上报异议 (string query )
     * id 列表id (integer query required)
     * name 学生姓名 (string query )
     * oldType 是否老带新 (string query )
     * performanceRefundStatus 业绩扣费状态 (string query )
     * performanceStatus 业绩发放状态 (string query )
     * referralType 是否老生续读 (string query )
     */
    get: (p, c) => $.get("/api/bms/personnel/monthReviewTeacher/details", p, c)
  },
  monthReviewTeacher_exportEnrollForPersonnel: {
    /*
     * 人事平台-招生业绩核对-导出
     */
    get: (p, c) =>
      $.get(
        "/api/bms/personnel/monthReviewTeacher/exportEnrollForPersonnel",
        p,
        c
      )
  },
  monthReviewTeacher_exportExtraPayForPersonnel: {
    /*
     * 人事平台-退费业绩核对-导出
     */
    get: (p, c) =>
      $.get(
        "/api/bms/personnel/monthReviewTeacher/exportExtraPayForPersonnel",
        p,
        c
      )
  },
  monthReviewTeacher_exportRefundForPersonnel: {
    /*
     * 人事平台-退费业绩核对-导出
     */
    get: (p, c) =>
      $.get(
        "/api/bms/personnel/monthReviewTeacher/exportRefundForPersonnel",
        p,
        c
      )
  },
  monthReviewTeacher_listEnroll: {
    /*
     * 内部管理-招生业绩核对-列表
     */
    get: (p, c) =>
      $.get("/api/bms/personnel/monthReviewTeacher/listEnroll", p, c)
  },
  monthReviewTeacher_listEnrollForPersonnel: {
    /*
     * 人事平台-招生业绩核对-列表
     */
    get: (p, c) =>
      $.get(
        "/api/bms/personnel/monthReviewTeacher/listEnrollForPersonnel",
        p,
        c
      )
  },
  monthReviewTeacher_listExtraPay: {
    /*
     * 内部管理-补缴业绩核对-列表
     */
    get: (p, c) =>
      $.get("/api/bms/personnel/monthReviewTeacher/listExtraPay", p, c)
  },
  monthReviewTeacher_listExtraPayForPersonnel: {
    /*
     * 人事平台-补缴业绩核对-列表
     */
    get: (p, c) =>
      $.get(
        "/api/bms/personnel/monthReviewTeacher/listExtraPayForPersonnel",
        p,
        c
      )
  },
  monthReviewTeacher_listRefund: {
    /*
     * 内部管理-退费业绩核对-列表
     */
    get: (p, c) =>
      $.get("/api/bms/personnel/monthReviewTeacher/listRefund", p, c)
  },
  monthReviewTeacher_listRefundForPersonnel: {
    /*
     * 人事平台-退费业绩核对-列表
     */
    get: (p, c) =>
      $.get(
        "/api/bms/personnel/monthReviewTeacher/listRefundForPersonnel",
        p,
        c
      )
  },
  monthReviewTeacher_updatePerformanceTime: {
    /*
     * 单个更新业绩发放时间或业绩扣费时间
     * performanceStatus 业绩发放状态|业绩扣费状态， 历史扣费和历史发放可以不填时间 (string query )
     * performanceTime 业绩发放时间|业绩扣费时间 (string query )
     * schoolRollIds 合同编号 (array query required)
     * type 类型：业绩发放时间|业绩扣费时间 (string query required)
     */
    put: (p, c) =>
      $.put("/api/bms/personnel/monthReviewTeacher/updatePerformanceTime", p, c)
  }
};
